export default "__VITE_ASSET__l1P9Mt9P__"